import React from "react";
import { cn } from "@/lib/utils";
import { useSidebar } from "@/contexts/SidebarContext";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Toaster } from "@/components/ui/Toast";

interface DashboardLayoutProps {
  children: React.ReactNode;
  activePath?: string;
  contentClassName?: string;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  activePath = "/",
  contentClassName,
}) => {
  const { collapsed } = useSidebar();

  return (
    <div
      data-testid="dashboard-layout"
      className="min-h-screen bg-slate-50 dark:bg-slate-950"
    >
      <Sidebar activePath={activePath} />
      <Header />

      <main
        data-testid="main-content"
        className={cn(
          "pt-16 min-h-screen",
          "transition-all duration-200",
          collapsed ? "pl-16" : "pl-64",
        )}
      >
        <div
          className={cn("p-6 md:p-8 max-w-[1600px] mx-auto", contentClassName)}
        >
          {children}
        </div>
      </main>

      {/* Global Toast Layer */}
      <Toaster />
    </div>
  );
};
